module.exports = __webpack_public_path__ + "static/media/four.2107bb1a.svg";